module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Thin.ttf
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Thin.ttf
// module chunks = styles